import LoginBg1 from '@/assets/images/login/login-bg-1.svg';
import LoginBg2 from '@/assets/images/login/login-bg-2.svg';
import LoginBg3 from '@/assets/images/login/login-bg-3.svg';
import LoginBg4 from '@/assets/images/login/login-bg-4.svg';

export function AuthBackground() {
  return (
    <>
      <img
        src={LoginBg1}
        alt=""
        className="fixed bottom-0 right-0 pointer-events-none z-0 hidden md:block md:w-64 lg:w-80 xl:w-96 2xl:w-auto"
      />
      <img
        src={LoginBg2}
        alt=""
        className="fixed top-0 right-0 pointer-events-none z-0 hidden md:block md:w-32 lg:w-40 xl:w-48 2xl:w-56"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed md:left-[40px] lg:left-[60px] xl:left-[80px] top-0 pointer-events-none z-0 md:w-[160px] md:h-[160px] lg:w-[220px] lg:h-[220px] xl:w-[280px] xl:h-[280px] rotate-[230deg] hidden md:block"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed md:left-[-15px] lg:left-[-20px] xl:left-[-25px] md:top-[280px] lg:top-[320px] xl:top-[360px] pointer-events-none z-0 md:w-[80px] md:h-[80px] lg:w-[110px] lg:h-[110px] xl:w-[140px] xl:h-[140px] hidden md:block"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed md:left-[80px] lg:left-[120px] xl:left-[160px] md:top-[420px] lg:top-[480px] xl:top-[540px] pointer-events-none z-0 md:w-[40px] md:h-[40px] lg:w-[52px] lg:h-[52px] xl:w-[64px] xl:h-[64px] hidden md:block"
      />
      <img
        src={LoginBg4}
        alt=""
        className="fixed left-0 bottom-0 pointer-events-none z-0 hidden md:block md:w-64 lg:w-80 xl:w-96 2xl:w-auto"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed top-0 right-[-60px] pointer-events-none z-0 w-[120px] h-[120px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed top-[50px] left-[-20px] pointer-events-none z-0 w-[45px] h-[45px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed top-[250px] left-[-10px] pointer-events-none z-0 w-[45px] h-[45px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed top-[350px] left-[-5px] pointer-events-none z-0 w-[100px] h-[100px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed bottom-[300px] right-[10px] pointer-events-none z-0 w-[25px] h-[25px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed bottom-[200px] right-[30px] pointer-events-none z-0 w-[75px] h-[75px] md:hidden"
      />
      <img
        src={LoginBg3}
        alt=""
        className="fixed bottom-[-20px] right-[-20px] pointer-events-none z-0 w-[120px] h-[120px] md:hidden"
      />
    </>
  );
}
